import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker, MobileDatePicker } from "@mui/x-date-pickers";
import { Dispatch, SetStateAction } from "react";
import { Grid } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useScreenWidth } from "../../media";

type DateRangePickerProps = {
	startDate: Date;
	endDate: Date;
	setStartDate: Dispatch<SetStateAction<Date>>;
	setEndDate: Dispatch<SetStateAction<Date>>;
};

export const DateRangePicker = ({
	startDate,
	setStartDate,
	endDate,
	setEndDate,
}: DateRangePickerProps) => {
	const mediumScreen = useScreenWidth("sm");

	const DatePickerComponent = mediumScreen
		? DesktopDatePicker
		: MobileDatePicker;

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<Grid container spacing={2} alignItems="center">
				<Grid item>
					<DatePickerComponent
						label="Start Date"
						value={startDate}
						onChange={(newDate: Date | null) =>
							newDate && setStartDate(newDate)
						}
						maxDate={endDate}
					/>
				</Grid>
				<Grid item>
					<DatePickerComponent
						label="End Date"
						value={endDate}
						onChange={(newDate: Date | null) => newDate && setEndDate(newDate)}
						minDate={startDate}
					/>
				</Grid>
			</Grid>
		</LocalizationProvider>
	);
};
